import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { FacturacionElectronicaReenviarFacturaComponent} from './FacturacionElectronicaReenviarFactura.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'ReenviarFactura',
        component: FacturacionElectronicaReenviarFacturaComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReenviarFactura'
        } 
    }
];

@NgModule({
    declarations: [
        FacturacionElectronicaReenviarFacturaComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        FacturacionElectronicaReenviarFacturaComponent
    ],
    bootstrap: [FacturacionElectronicaReenviarFacturaComponent]
})

export class FacturacionElectronicaReenviarFacturaModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/FacturacionElectronicaReenviarFactura/FacturacionElectronicaReenviarFactura.module.ts